import { render, staticRenderFns } from "./_CreateTache.vue?vue&type=template&id=a863e74a&scoped=true&"
import script from "./_CreateTache.vue?vue&type=script&lang=ts&"
export * from "./_CreateTache.vue?vue&type=script&lang=ts&"
import style0 from "./_CreateTache.vue?vue&type=style&index=0&id=a863e74a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a863e74a",
  null
  
)

export default component.exports